import ScrollReveal from "./ScrollReveal";

const Mission = () => (
  // Optimization: Switched to solid bg-primary to improve paint speed
  <section className="py-24 px-4 bg-primary">
    <div className="max-w-4xl mx-auto text-center">
      <ScrollReveal>
        {/* Fix: H2 is correct for this section level */}
        <h2 className="text-3xl sm:text-4xl font-bold text-background mb-8">Our Mission</h2>
      </ScrollReveal>
      <ScrollReveal delay={0.1}>
        {/* Fix: Standard text tag is fine here since it follows an H2 */}
        <p className="text-background text-lg leading-relaxed">
          Our mission as a Real Estate Transaction Management Company is to manage the administrative tasks, allowing you to concentrate on expanding your business. We believe your time is best invested in prospecting and engaging with clients, rather than in paperwork. With our careful handling of your transactions, you can be confident in their smooth execution. We collaborate with various parties involved in the transaction, including title & escrow, closing attorneys, and loan officers, to ensure seamless closings. Our success is intrinsically linked to yours, making us a committed partner in your business growth.
        </p>
      </ScrollReveal>
    </div>
  </section>
);

export default Mission;